export default __webpack_public_path__ + "images/62619de4a73b7b1da93572b2452396ab-business.png";